import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * Colours and route paths for the Games section.
 *
 * Each game keeps ONE colour everywhere it appears — in the take-up bars, in
 * the 30-day trend, in the play-volume donut and on its own tab. Four games
 * across five charts is exactly the situation where a shifting palette makes a
 * reader compare the wrong two things.
 */
export const GAME_COLORS = {
  chess: CHART_COLORS.moss, // a chessboard, and the most "serious" of the four
  wordSearch: CHART_COLORS.teal,
  blockfill: CHART_COLORS.orange,
  quiz: CHART_COLORS.pink
};

export const GAME_ORDER = ['chess', 'wordSearch', 'blockfill', 'quiz'];

/** URL segment per game, so the tab strip and the fetchers cannot disagree. */
export const GAME_PATHS = {
  chess: 'chess',
  wordSearch: 'word-search',
  blockfill: 'block-fill',
  quiz: 'quiz'
};

export const gameColor = (key) => GAME_COLORS[key] || CHART_COLORS.gray;

export const GAME_RAMP = GAME_ORDER.map((key) => GAME_COLORS[key]);

/**
 * Chess results, in the order the donut lists them: the player's own outcomes
 * first, then the bot's, then the two ways a game ends without being played
 * out. Green for a win, amber for a draw, gray for walking away — RESIGNING IS
 * NOT COLOURED AS A FAILURE. Somebody stopping a game they were losing is
 * ordinary play, and a red slice would invite reading it as a problem.
 */
export const CHESS_RESULT_RAMP = [
  CHART_COLORS.greenDeep, // Player won
  CHART_COLORS.amber, // Draw
  CHART_COLORS.brand, // Bot won
  CHART_COLORS.gray, // Resigned
  CHART_COLORS.orange // Ran out of time
];

export const CHESS_MODE_RAMP = [CHART_COLORS.blue, CHART_COLORS.teal, CHART_COLORS.pink];

/** Easy → medium → hard, cool to warm. */
export const DIFFICULTY_RAMP = [CHART_COLORS.teal, CHART_COLORS.amber, CHART_COLORS.red];

/** Ordered bands — short/low to long/high. */
export const SEQUENCE_RAMP = [
  CHART_COLORS.teal,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.orange,
  CHART_COLORS.pink
];

/** Accuracy: low is not shameful, so it starts amber rather than red. */
export const ACCURACY_RAMP = [
  CHART_COLORS.amber,
  CHART_COLORS.orange,
  CHART_COLORS.blue,
  CHART_COLORS.greenDeep,
  CHART_COLORS.green
];

/**
 * Quiz attempt status. 'Walked away' is gray, not red: somebody leaving a quiz
 * is information about the quiz, not a mark against them.
 */
export const QUIZ_STATUS_RAMP = [CHART_COLORS.greenDeep, CHART_COLORS.amber, CHART_COLORS.gray];

/** One game, two, three, all four — deepening as breadth grows. */
export const BREADTH_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep
];

/** Enough distinct hues for a ranked list of the nine quiz types. */
export const RANK_RAMP = [
  CHART_COLORS.brand,
  CHART_COLORS.pink,
  CHART_COLORS.teal,
  CHART_COLORS.orange,
  CHART_COLORS.blue,
  CHART_COLORS.greenDeep,
  CHART_COLORS.moss,
  CHART_COLORS.amber,
  CHART_COLORS.brandSoft
];
